/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Local Library.
 * @export
 */
export const ICON_LOCAL_LIBRARY = (
  <svg fill="#000000" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M15 4.8927C15 6.5527 13.66 7.8927 12 7.8927C10.34 7.8927 9 6.5527 9 4.8927C9 3.2327 10.34 1.8927 12 1.8927C13.66 1.8927 15 3.2327 15 4.8927ZM5.32 8.0927C7.88 8.5527 10.18 9.7427 12 11.4427C13.82 9.7427 16.12 8.5527 18.68 8.0927C19.89 7.8827 21 8.8427 21 10.0727V16.9927C21 17.9527 20.23 18.8827 19.29 19.0127C16.77 19.3327 14.48 20.3827 12.61 21.9127C12.26 22.1927 11.69 22.1627 11.34 21.8727C9.48 20.3527 7.21 19.3227 4.71 19.0027C3.72 18.8727 3 17.9927 3 16.3127V10.0727C3 8.8427 4.11 7.8827 5.32 8.0927Z"
      fill="#707070"
      fillRule="evenodd"
    />
  </svg>
);
